export default __webpack_public_path__ + "static/media/Bottom-Banner.082ef9cf.jpg";